// extracted by mini-css-extract-plugin
module.exports = {"modalFooterButton":"RequestInfoModal_modalFooterButton__1V9hn","requestInfoFormWrapper":"RequestInfoModal_requestInfoFormWrapper__1hoih"};